import React, { FC, ReactElement } from 'react';
import classnames from 'classnames/bind';
import Spinner from 'react-bootstrap/Spinner';
import styles from './default-spinner-container.scss';
import Overlay from 'react-overlay-component';
import { useSelector } from 'react-redux';
import { selectSpinnerStatus, SpinnerStatus } from '@/store/system';

const cx = classnames.bind(styles);

type DefaultSpinnerContainerProps = {
  children: ReactElement;
};

const DefaultSpinnerContainer: FC<DefaultSpinnerContainerProps> = ({
  children,
}: DefaultSpinnerContainerProps) => {
  const spinnerStatus: SpinnerStatus = useSelector(selectSpinnerStatus);

  const configs = {
    animate: true,
    clickDismiss: false,
    escapeDismiss: false,
    focusOutline: false,
    showCloseIcon: false,
    contentClass: cx([styles.spinnerContainer]),
  };

  return (
    <>
      <div>{children}</div>
      <Overlay configs={configs} isOpen={spinnerStatus.isShowing}>
        {spinnerStatus.type === 'default' && (
          <Spinner animation="border" role="status" variant="primary" />
        )}
        {spinnerStatus.type === 'mobile' && (
          <Spinner
            animation="border"
            role="status"
            variant="primary"
            style={{ width: '10rem', height: '10rem', borderWidth: '1rem' }}
          />
        )}
      </Overlay>
    </>
  );
};

export default DefaultSpinnerContainer;
